
import { notification } from 'antd';

export function getBase64 (img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
}

export function beforeUpload (file) {
    const ListIMG = ['image/jpeg', 'image/png', 'application/pdf'];
    const isIMG =  ListIMG.indexOf(file.type) === -1 ? false : true ;

    if ( !isIMG ) {
      notification['error']({
          message: 'You can only upload JPG or PNG file!',
      });
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      notification['error']({
          message: 'Image must be smaller than 2MB! ',
      });
    }
    return isIMG && isLt2M;
}


export function onChangeFile(info) {
  const { status } = info.file;
  if (status !== 'uploading') {
    console.log(info.file, info.fileList);
  }
  if (status === 'done') {
    notification['success']({
        message: `${info.file.name} file uploaded successfully.`,
    });
  } else if (status === 'error') {
    notification['error']({
        message: `${info.file.name} file upload failed.`,
    });
  }
}
